import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/common";

const BG = "https://images.unsplash.com/photo-1553051021-9f94520a6cad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const { user, setUser } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-[#FDFBF7]">
      <div className="relative hidden lg:block">
        <img src={BG} alt="Taller de carpintería" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#1E1B18]/60" />
        <div className="relative h-full flex flex-col justify-end p-14 text-stone-50">
          <p className="text-xs uppercase tracking-[0.3em] text-amber-400 mb-4">Sistema de gestión</p>
          <h1 className="text-5xl xl:text-6xl font-extrabold tracking-tight leading-[1.05]">VICON<br />CARPINTERIA</h1>
          <p className="mt-4 max-w-md text-stone-300">Ventas, cotizaciones, agenda de trabajos e inventario del taller en un solo lugar.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="login-form">
          <div>
            <div className="h-12 w-12 rounded-lg bg-amber-700 grid place-items-center text-white font-display font-extrabold text-xl mb-6">V</div>
            <h2 className="text-3xl font-extrabold tracking-tight">Iniciar sesión</h2>
            <p className="text-sm text-stone-500 mt-1">Accede al panel de tu taller</p>
          </div>
          <Field label="Correo electrónico">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </Field>
          <Field label="Contraseña">
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </Field>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full h-11 bg-amber-700 hover:bg-amber-800" data-testid="login-submit-button">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Entrar
          </Button>
        </form>
      </div>
    </div>
  );
}
